export default "__VITE_ASSET__9b1d95d7__"